// @flow
import './style/allsaints.css';
import withClientPage from '../../hoc/withClientPage';
import withTemplate from '../../hoc/templates/withTemplate';
import withBasic from '../../hoc/templates/withBasic';
import React,{useEffect} from 'react';

// This function disables the auto zoom on iOS devices
const CheckUserAgent = () => {
  useEffect(() => {
    const editMetaTag = () => {
      if (/iPhone/.test(navigator.userAgent)) {
        const metaViewportTag = document.head.querySelector('meta[name="viewport"]');
        metaViewportTag.content = 'width=device-width, initial-scale=1, maximum-scale=1';
        return null;
      }
    };
    document.addEventListener('DOMContentLoaded', editMetaTag());
    document.removeEventListener('DOMContentLoaded', editMetaTag());
  }, [])
  return null; 
};

const url = window.location.href;

let language = null;

switch (true) {
  case (url.includes('allsaints.de')):
    language = 'de';
    break;
  case (url.includes('allsaints.fr')):
    language = 'fr';
    break;
  default:
    language = 'en';
    break;
}

const PassedProps = {
  clientBodyClassNames: 'container-fluid allsaints-main',
  header: 'none',
  headingText: 'allsaints.headingText',
  buttonClassNames: 'btn btn-secondary mt-2 check-balance-button',
  buttonText: 'allsaints.buttonText',
  cardInputLabel: 'allsaints.cardLabel',
  pinInputLabel: 'allsaints.pinLabel',
  cardInputPlaceholder: 'allsaints.cardPlaceholder',
  pinInputPlaceholder: 'allsaints.pinPlaceholder',
  showEnhancedResults: false,
  showCardEOV: false,
  langOverride: language,
  justifyContent: 'center',
  labelAnimation: false,
  resultsHeadingText: 'allsaints.resultsHeading',
  cardLength: '16',
};

const clientPageProps = {
  title: 'allsaints.title',
  favicon: '/allsaints.ico',
  callTranslations: PassedProps.showEnhancedResults,
  errorMsg: 'allsaints.errorMsg'
};
const AGBGC = () => <CheckUserAgent />;

export default withClientPage(withTemplate(withBasic(AGBGC), PassedProps), clientPageProps);
